<style lang="scss" scoped>
@import '../css/main.scss';
</style>

<template>
  <div class="donga-audit">
    <audit-header></audit-header>
    <div class="audit-template main-template">
      <main role="main" class="audit-main">
        <div class="visual-top">
          <div class="col-container">
            <div class="visual-logo">
              <img src="../img/main-visual-logo.png" alt="CLEAN:D">
            </div>
            <h2 class="visual-tit">사이버 감사실은 제보자를 존중하며 <br class="pc-show">투명하고 공정하게 수행하겠습니다.</h2>
            <p class="visual-txt">"우리는 사회 정의에 따라 기업의 사회적 책임을 다하고, 글로벌시장에서 인정받는 우수한 제품을 개발하여 <br class="pc-show">인류의 건강과 복지향상에 이바지한다"는 경영이념에 따라 회사경영 및 기업활동에 있어 <br class="pc-show">'기업윤리'를 최우선 가치로 생각하며, 투명하고 공정하며 합리적인 업무 수행을 위해 노력하겠습니다.</p>
            <router-link to="/reporting" class="default-link report-link">제보하기</router-link>
            <i class="down-arrow pc-show">아래로 내려가기</i>
          </div>
        </div>
        <div id="main-sections" style="background:#f3f3f3">
          <section class="main-banner-list" style="background:#fff">
            <div class="col-container pc-container">
              <ul class="banner-list">
                <li class="list-item">
                  <router-link to="/reportguide">
                    <i class="item-icon guide">글쓰기</i>
                    <h3 class="item-tit">제보안내</h3>
                    <p class="item-txt">제보자 보호 의무, 제보방법 및 처리절차에 대한 것들을 안내해드립니다.</p>
                  </router-link>
                </li>
                <li class="list-item">
                  <router-link to="/reporting">
                    <i class="item-icon do">확성기</i>
                    <h3 class="item-tit">제보하기</h3>
                    <p class="item-txt">익명을 바탕으로 한 명확한 제보를 위한 공간입니다.</p>
                  </router-link>
                </li>
                <li class="list-item">
                  <router-link to="/reportinquiry">
                    <i class="item-icon confirm">컴퓨터 체크</i>
                    <h3 class="item-tit">제보확인</h3>
                    <p class="item-txt">제보해주신 제보를 바탕으로 감사실의 댓글과 처리 진행결과를 보여줍니다.</p>
                  </router-link>
                </li>
              </ul>
            </div>
          </section>
          <section class="main-banner-area ethics">
            <div class="col-container">
              <h2 class="section-tit">윤리경영</h2>
              <span class="sub-tit">투명하고 공정하게.</span>
              <p class="section-txt">윤리경영이란 회사경영 및 기업활동에 있어 '기업윤리'를 최우선 가치로 생각하며, 투명하고 공정하며 <br class="pc-show">합리적인 업무 수행을 추구하는 경영정신입니다.</p>
            </div>
          </section>
          <br id="intro-br" ref="intro-br" style="height:0;">
          <section class="main-banner-area audit" ref="intro" id="intro">
            <div class="col-container">
              <h2 class="section-tit">CLEAN :D</h2>
              <span class="sub-tit">사이버 감사실은 철저한 보안으로 <br>제보자 보호에 최선을 다하겠습니다.</span>
              <div class="section-img">
                <img src="../img/banner-loudspeaker.png" alt="확성기">
              </div>
              <p class="section-txt">그룹사 사이버 감사실은 회사에 대한 경영감사 및 부정감사 업무를 수행하고 있습니다. <br class="pc-show">그룹사 임직원의 불공정한 업무처리나 직위를 이용한 부당한 요구 및 비리 사실에 대한 제보를 받으며 비공개 방식으로 처리됩니다.</p>
              <p class="section-txt last">귀하의 용기 있는 제보와 소중한 한마디가 부정부패가 없는 투명경영의 초석이 될 뿐 아니라 그룹사 및 이해관계자 <br class="pc-show">모두의 발전에 도움이 됩니다.</p>
              <div class="section-links">
                <router-link to="/reporting" class="link default-link">제보하러가기</router-link>
                <router-link to="/reportinquiry" class="link default-link">제보결과확인하기</router-link>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>
    <audit-footer></audit-footer>
  </div>
</template>
<script>
import AuditHeader from '@/components/AuditHeader'
import AuditFooter from '@/components/AuditFooter'
export default {
  name: 'Main',
  components: {
    'audit-header': AuditHeader,
    'audit-footer': AuditFooter
  },
  created () {
    this.openMsgBox() // popup on/off
    // this.openMsgBox2() // popup on/off
  },
  methods: {
    getCookie (cookieName) {
      var isCookie = false
      var start, end
      var i = 0

      // cookie 문자열 전체를 검색
      while (i <= document.cookie.length) {
        start = i
        end = start + cookieName.length
        // cookie_name과 동일한 문자가 있다면
        if (document.cookie.substring(start, end) === cookieName) {
          isCookie = true
          break
        }
        i++
      }

      // cookie_name 문자열을 cookie에서 찾았다면
      if (isCookie) {
        start = end + 1
        end = document.cookie.indexOf(';', start)
        // 마지막 부분이라는 것을 의미(마지막에는 ";"가 없다)
        if (end < start) {
          end = document.cookie.length
        }
        // cookie_name에 해당하는 value값을 추출하여 리턴한다.
        return document.cookie.substring(start, end)
      }
      // 찾지 못했다면
      return ''
    },
    openMsgBox () {
      /* *
       * sDate, eDate
       * AS-IS yyyy-MM-dd
       * TO-BE yyyy-MM-dd HH:mm:ss
       *
       * YYYY-MM-DD만 선언 돼 있으면 09:00:00 default
       * 파일 선반영하여 특정시간에 띄우기 위해 시간 추가
       * 익스플로러에서 hhmmss 포맷형식이 안먹히는 현상이 있어 replace 처리
       * */
      var today = new Date()
      //var sDate = '2025-12-22 08:00:00' // 해당 일부터 팝업 on
      //var eDate = '2026-01-05 08:00:00' // 해당 일부터 팝업 off
      var sDate = '2026-02-10 08:00:00' // 해당 일부터 팝업 on
      var eDate = '2026-02-19 08:00:00' // 해당 일부터 팝업 off

      today = new Date(today.getTime() - (today.getTimezoneOffset() * 60000)).toISOString().replace(/T/, ' ').replace(/\..+/, '')
      sDate = sDate.replace(/T/, ' ').replace(/\..+/, '')
      eDate = eDate.replace(/T/, ' ').replace(/\..+/, '')

      if (today < sDate || today > eDate) {
        return false
      }
      var left = 10 + window.screenLeft
      var eventCookie = this.getCookie('popupname')
      // 쿠키가 없을 경우에만 (다시 보지 않기를 선택하지 않았을 경우.)
      if (eventCookie !== 'done') {
        if (navigator.userAgent.indexOf('Chrome') > -1) {
          window.open('/auditpopup', 'popup01', 'left=' + left + ', top=10, width=645, height=880, scrollbars= 0, toolbar=0, menubar=no')
        } else {
          window.open('/auditpopup', 'popup01', 'left=' + left + ', top=10, width=645, height=880, scrollbars= 0, toolbar=0, menubar=no')
        }
      }
    }
    // openMsgBox2 () {
    //   var eventCookie = this.getCookie('popupname2')
    //   // 쿠키가 없을 경우에만 (다시 보지 않기를 선택하지 않았을 경우.)
    //   if (eventCookie !== 'done') {
    //     if (navigator.userAgent.indexOf('Chrome') > -1) {
    //       window.open('/auditpopup2', 'popup02', 'left=500, top=10, width=586, height=415, scrollbars= 0, toolbar=0, menubar=no')
    //     } else {
    //       window.open('/auditpopup2', 'popup02', 'left=500, top=10, width=586, height=420, scrollbars= 0, toolbar=0, menubar=no')
    //     }
    //   }
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue